import React from "react";

import { withTranslation } from "react-i18next";
import APIErrorHelper from "../../../../helpers/APIErrorHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import WebConfiguration from "./webConfiguration/WebConfiguration";
import VMConfiguration from "./vmConfiguration/VMConfiguration";
import { Button, Col, Container, Row } from "react-bootstrap";
import equals from "fast-deep-equal";

class ConfigurationTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      configuration: this.props.examination.configuration,
      isDirty: false,
      isValid: false,
      apiError: "",
    };

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleSEBConfigurationDownload = this.handleSEBConfigurationDownload.bind(
      this
    );
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.setState({
      configuration: Object.assign({}, this.props.examination.configuration)
    });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!equals(prevProps.examination, this.props.examination)) {
      this.setState({
        configuration: Object.assign({}, this.props.examination.configuration),
      });
    }
  }

  handleUpdate(configuration) {
    this.setState({
      isDirty: true,
      configuration,
    });
  }

  async handleSEBConfigurationDownload() {
    try {
      await CamplaCoreService.getExaminationSEBConfiguration(
        this.props.examination._id,
        `${this.props.examination.name}.seb`
      );
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  async handleSubmit() {
    try {
      this.setState({ isDirty: false });
      await CamplaCoreService.updateExaminationConfiguration(
        this.props.examination._id,
        { configuration: this.state.configuration }
      );
      this.props.onFetchData();
    } catch (err) {
      //Todo: Add correct errors according to documentation
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        ),
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <>
        <Container className="pl-0 pr-0">
          {this.state.apiError ? (
            <Row>
              <Col>{this.state.apiError}</Col>
            </Row>
          ) : (
            ""
          )}
          <Row className="mt-3 mb-2">
            <Col>
              <h4>{t("SingleExamination.ConfigurationTabTitle")}</h4>
            </Col>
            <Col className="d-flex flex-row-reverse">
              <Button
                className="btn btn-green"
                id="submit-btn"
                disabled={
                  !this.state.isDirty ||
                  !this.state.isValid ||
                  (this.props.examination.status !== 1 &&
                    this.props.examination.status !== 50 &&
                    this.props.examination.status !== 51 &&
                    this.props.examination.status !== 52 &&
                    this.props.examination.status !== 53)
                }
                onClick={this.handleSubmit}
              >
                {t("SingleExamination.ConfigurationTab.Submit")}
              </Button>
            </Col>
          </Row>
          <Row>
            <Col>
              {this.props.examination &&
              this.props.examination.instanceTemplate.type === 1 ? (
                <WebConfiguration
                  disabled={
                    this.props.examination.status !== 1 &&
                    this.props.examination.status !== 50 &&
                    this.props.examination.status !== 51 &&
                    this.props.examination.status !== 52 &&
                    this.props.examination.status !== 53
                  }
                  onUpdate={this.handleUpdate}
                  onSEBConfigurationDownload={
                    this.handleSEBConfigurationDownload
                  }
                  onValid={(valid) => this.setState({ isValid: valid })}
                  isDirty={this.state.isDirty}
                  securityLevel={this.props.examination.securityLevel}
                  examination={this.props.examination}
                  configuration={this.state.configuration}
                />
              ) : (this.props.examination &&
                  this.props.examination.instanceTemplate.type === 0 ? (
                  <VMConfiguration
                      examination={this.props.examination}
                      onFetchData={this.props.onFetchData}
                      onUpdate={this.handleUpdate}
                      onValid={(valid) => this.setState({ isValid: valid })}
                      isDirty={this.state.isDirty}
                      configuration={this.state.configuration}
                      instanceTemplateConfig={
                        this.props.examination.instanceTemplate.configuration
                      }
                  />
              ) : "")}
            </Col>
          </Row>
        </Container>
      </>
    );
  }
}

export default withTranslation()(ConfigurationTab);
